import { combineReducers } from 'redux';
import { reducer } from 'redux-oidc';
import {
  settingsDesignSystemReducer,
  settingsDisclaimersReducer,
  settingsBrowserTitleReducer
} from './setting-reducer';

import {
  requiredDocumentCountFetchedReducer,
  isQDEnabledReducer,
  qdExternalCommercialModelsCountReducer,
  qdExternalConsumerModelsCountReducer,
  currentApplicationsCountReducer
} from './counts-qd-enabled-reducer';
import { evaluateQDModelsReducer, loanApplicationHistoryReducer } from './loan-application-reducers';
import healthCheckReducer from './health-check-reducer';
import antiVirusReducer from './anti-virus-reducer';
import docHistoryReducer from './doc-history-reducers';
import docReducer from './doc-reducer';
import loadingReducer from './loading';
import currentRequestsReducer from './current-applications-reducer';

export default combineReducers({
  doc: docReducer,
  oidc: reducer,
  healthCheck: healthCheckReducer,
  designSystemTemplate: settingsDesignSystemReducer,
  disclaimersPrompt: settingsDisclaimersReducer,
  browserTitle: settingsBrowserTitleReducer,
  loading: loadingReducer,
  docHistories: docHistoryReducer,
  reqDocsFetched: requiredDocumentCountFetchedReducer,
  qdExternalCommercialModelsFetched: qdExternalCommercialModelsCountReducer,
  qdExternalConsumerModelsFetched: qdExternalConsumerModelsCountReducer,
  isQDEnabled: isQDEnabledReducer,
  loanApplications: evaluateQDModelsReducer,
  loanApplicationHistory: loanApplicationHistoryReducer,
  antiVirusScanResult: antiVirusReducer,
  currentApplications: currentRequestsReducer,
  currentApplicationsFetched: currentApplicationsCountReducer,
});
